angular.module('smartorg.r6.mgmts.pypeerLog', []);
require('./pypeer-log-directive');
require('../../css/app.css');
module.exports = 'smartorg.r6.mgmts.pypeerLog';
//# sourceMappingURL=app.js.map


// WEBPACK FOOTER //
// ./app/widgets/management/pypeer-log/app/js/plumbing/app.js